var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("\n            Routing in Progress\n        "),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "md-default dialog-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Wait")]
        ),
        _c(
          "md-button",
          {
            staticClass: "md-primary dialog-button",
            on: { click: _vm.handleSend },
          },
          [_vm._v("\n            Send it Now\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _vm._v(
        "\n        Re-routing is still in progress, which may affect the order of stops in this trip.\n        "
      ),
      _c("br"),
      _vm._v(
        "\n        Would you like to wait until routing is complete before sending the run sheet?\n    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }